import {
  APP_DETAILS_REQUEST,
  APP_RECOMMEND_REQUEST,
  APP_GROUP_REQUEST,
  APP_DETAILS_GIFT_REQUEST,
  APP_DETAILS_GIFT_RECEIVE_REQUEST,
  APP_FORUM_RELATED_REQUEST,
} from '../constants/detail';

export const getAppDetails = param => ({
  type: APP_DETAILS_REQUEST,
  ...param,
});

export const geAppRecommend = param => ({
  type: APP_RECOMMEND_REQUEST,
  ...param,
});

export const getAppGroup = param => ({
  type: APP_GROUP_REQUEST,
  ...param,
});

export const getAppGift = param => ({
  type: APP_DETAILS_GIFT_REQUEST,
  ...param,
});

export const appGiftReceive = param => ({
  type: APP_DETAILS_GIFT_RECEIVE_REQUEST,
  ...param,
});

export const getAppForumRelated = param => ({
  type: APP_FORUM_RELATED_REQUEST,
  payload: param,
});
